import { render } from "./ActivitatMaterialView.vue?vue&type=template&id=4537663a&scoped=true"
import script from "./ActivitatMaterialView.vue?vue&type=script&lang=js"
export * from "./ActivitatMaterialView.vue?vue&type=script&lang=js"

import "./ActivitatMaterialView.vue?vue&type=style&index=0&id=4537663a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4537663a"]])

export default __exports__